export default "__VITE_ASSET__facdf031__"